import { render, staticRenderFns } from "./UsernameAndPassword.vue?vue&type=template&id=c52c9d48&scoped=true&"
import script from "./UsernameAndPassword.vue?vue&type=script&lang=ts&"
export * from "./UsernameAndPassword.vue?vue&type=script&lang=ts&"
import style0 from "./UsernameAndPassword.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UsernameAndPassword.vue?vue&type=style&index=1&id=c52c9d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52c9d48",
  null
  
)

export default component.exports